import { getRouterBasename } from '@/utils/routerBasename';

const config = window.__CONFIG__ ?? {};

const stripTrailingSlash = (url?: string) => (url ?? '').replace(/\/$/, '');

export const API_URL = stripTrailingSlash(config.REACT_APP_API_URL);
export const BASE_URL = stripTrailingSlash(config.REACT_APP_BASE_URL);
/** CloudFront origin for resolving relative HLS cdnFile paths (matches main UI CLOUDFRONT_URI). */
export const CLOUDFRONT_URL = config.REACT_APP_CLOUDFRONT_URL || 'https://cloudfront.jove.com';

export const GOOGLE_CLIENT_ID = config.REACT_APP_GOOGLE_CLIENT_ID ?? '';
export const MICROSOFT_CLIENT_ID = config.REACT_APP_MICROSOFT_CLIENT_ID ?? '';
export const MICROSOFT_TENANT_ID = config.REACT_APP_MICROSOFT_TENANT_ID ?? '';

/** SSO is enabled when a Google OAuth client ID is configured. */
export const ENABLE_SSO = !!GOOGLE_CLIENT_ID;

export const isMicrosoftSsoConfigured = (): boolean =>
    !!MICROSOFT_CLIENT_ID && !!MICROSOFT_TENANT_ID;

export const getSsoRedirectUri = (): string => {
    const basename = getRouterBasename();
    const path = basename ? basename.replace(/\/$/, '') : '';

    return `${window.location.origin}${path}`;
};
